import { Row } from 'react-table';

import { COLUMN_IDS } from '../constants';

/**
 * @param subRows - array of subRows
 * @returns sum of detections for each subRow that is selected to be included in the report
 */
export const sumIncludedDetections = (
    subRows: Row<TrqkGapChannelAudio>[],
): number =>
    subRows.reduce((acc: number, subRow: Row<TrqkGapChannelAudio>): number => {
        const detections = subRow.values?.[COLUMN_IDS.DETECTIONS] ?? 0;

        if (subRow.isSelected) {
            return acc + detections;
        }

        return acc;
    }, 0);
